export const socialData = [
  {
    name: "linkedin",
    url: "https://www.linkedin.com/in/jo%C3%A3o-guedes-827773211/",
  },
  {
    name: "github",
    url: "https://github.com/JoaoGuedes01",
  },
  {
    name: "codepen",
    url: "https://codepen.io/joaoguedes01",
  },
  {
    name: "youtube",
    url: "https://www.youtube.com/channel/UCPkhddYcAlduyP65SGxx2jA",
  },
];
